import { Component } from "@angular/core";
import { SmartRadioBlockComponent } from "@sdk/lib/smart-radio-block/smart-radio-block/smart-radio-block.component";
import { injectOptionalTransloco } from "@sdk/lib/utils/optional-transloco";

@Component({
  selector: "app-uplift-user-smart-radio-block",
  templateUrl: "./uplift-user-smart-radio-block.component.html",
  styleUrls: ["./uplift-user-smart-radio-block.component.css"],
})
export class UpliftUserSmartRadioBlockComponent extends SmartRadioBlockComponent {
  private _transloco = injectOptionalTransloco();

  correctAnswerLabel(): string {
    return (
      this._transloco?.translate("sdkBlocks.correctAnswerThe") ??
      "This is the correct answer"
    );
  }

  incorrectAnswerLabel(): string {
    return (
      this._transloco?.translate("sdkBlocks.incorrectAnswer") ??
      "This answer is incorrect"
    );
  }
}
